import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[ncFocus]',
  standalone: false,
})
export class FocusDirective {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onFocus = new EventEmitter<{ elementRef: ElementRef, ngControl: NgControl }>();

  constructor(private el: ElementRef, private control: NgControl) { }

  @HostListener('focus')
  focusChanged(): void {
    this.onFocus.emit({
      elementRef: this.el,
      ngControl: this.control,
    });
  }
}
